import React from 'react';

import ListPage from '../../../sharedModules/listPage/ListPage';

const ModuleUpdatesListPage: React.FC = () => {
  const moduleUpdateColumns = [
    {
      name: 'Module Name',
      selector: 'name',
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Last Deployed',
      selector: 'last_deployed_at',
      sortable: true,
      grow: 1,
    },
  ];

  return (
    <ListPage
      columns={moduleUpdateColumns}
      controller="admin/module_updates"
      queryPlaceholder="Filter by module name..."
      title="Module Updates"
    />
  );
};

export default ModuleUpdatesListPage;
